import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';

import './style.scss';

const ButtonIcon = ({
  className,
  children,
  pending,
  onClick,
  disabled,
  icon,
  style,
  text,
  tooltipText,
  tooltipPlace,
}) => {
  const handleClick = (e) => {
    return !disabled && onClick(e);
  };

  return (
    <>
      <div className={`${className} ${disabled || pending ? 'btn-disabled' : ''}`} style={style} onClick={handleClick}>
        <Icon name={icon} tooltipText={tooltipText} tooltipPlace={tooltipPlace} />

        {text && <div className="button-text">{text}</div>}

        {children || ''}
      </div>
    </>
  );
};

ButtonIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.string,
  pending: PropTypes.bool,
  tooltipText: PropTypes.string,
  tooltipPlace: PropTypes.string,
  text: PropTypes.string,
};

ButtonIcon.defaultProps = {
  tooltipText: '',
  tooltipPlace: 'bottom',
  className: '',
  disabled: false,
  pending: false,
  text: '',
  style: {},
  icon: '',
  onClick: () => {},
};

export { ButtonIcon };
